import { useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const useQueryParams = () => {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
};

export const useRemoveQueryParams = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const removeQueryParams = useCallback(
    (paramsToRemove: string[]) => {
      const searchParams = new URLSearchParams(location.search);

      paramsToRemove.forEach((param) => {
        searchParams.delete(param);
      });

      navigate({
        pathname: location.pathname,
        search: searchParams.toString(),
      });
    },
    [location, navigate],
  );

  return removeQueryParams;
};
